import Button from '@material-ui/core/Button';
import Icon from '@material-ui/core/Icon';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  withStyles
} from '@material-ui/core';
import { useAuth } from 'src/app/infra/auth';
import { useChats } from 'src/app/infra/chats';
import { useRoute } from 'src/app/infra/routes';
import { Wrapper } from 'src/app/public/login/login';
import { Optional } from 'src/app/shared/utils';
import { TipoExibicaoChat, VotacaoItem } from 'src/app/types/votacao';
import LogoHubert from '../svg/icone-cortado.png';

const View = styled.div`
  display: flex;
  width: 100%;
  align-items: center;

  ${({ theme }) => `
    min-height: 86px;
    background-color: ${theme.palette.primary.main};
    color: ${theme.palette.primary.contrastText};
  `}
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
  max-width: 1366px;
  margin: auto;
  padding: 1rem 2rem;
  z-index: 1;

  ${({ theme }) => theme.breakpoints.down('sm')} {
    padding: 1rem 0.5rem;
  }
`;

const Column = styled.div`
  display: flex;
  flex-direction: column;
`;

const Spacer = styled.div`
  flex: 1 1 auto;
`;

const Row = styled(Column)`
  flex-direction: row;
  align-items: center;
`;

const Flexible = styled.div`
  display: flex;
  align-items: center;
  margin: 0 1rem;

  ${({ theme }) => theme.breakpoints.down('sm')} {
    flex-direction: column;
    text-align: center;
  }
`;

const HiddenOnMobile = styled.div`
  display: contents;

  ${({ theme }) => theme.breakpoints.down('sm')} {
    display: none;
  }
`;

const HiddenOnDesktop = styled.div`
  display: none;

  ${({ theme }) => theme.breakpoints.down('sm')} {
    display: contents;
  }
`;

const StyledImg = styled.img`
  position: absolute;
  // right: 0;
`;

const OptionButton = styled(Button)`
  min-height: 0px;
  height: 40px;
  width: 148px;
`;

const Logo = styled.img`
  /* position: absolute; */
  /* right: ${(props) => `${props.sizes}rem`}; */
  /* padding-top: 24px; */
  width: ${(props) => `${props.width}px`};
`;

const P = styled.p`
  width: 100%;
`;

const Title = styled(Typography)`
  display: flex;
  align-items: center;
  font-weight: bold;
  margin: 0 1rem;

  ${({ theme }) => theme.breakpoints.down('sm')} {
    justify-content: center;
  }
`;

interface Props {
  data: VotacaoItem | undefined;
  canExit: boolean;
}

export default ({ data, canExit }: Props) => {
  const { session, authOff } = useAuth();
  const {
    params: { condominio }
  } = useRoute();
  const { openMovideskChat, openBlipChat } = useChats();
  const [tooltip, setTooltip] = useState(false);
  const [openClose, setOpenClose] = useState(false);
  const [customLayout, setCustomLayout] = useState(new Object());
  const [isCustom, setIsCustom] = useState(false);
  const [numberUnity, setNumberUnity] = useState(0);
  const [nameUnity, setNameUnity] = useState('none');

  const BlueOnGreenTooltip = withStyles({
    tooltip: {
      maxWidth: '100%'
    }
  })(Tooltip);

  const signOff = () => {
    authOff();
  };

  function Unidade({ list }) {
    return list.map((t) => <P>{t}</P>);
  }

  const idVisual = (identidadeVisual) => {
    if (identidadeVisual !== undefined) {
      setCustomLayout(identidadeVisual);
      setIsCustom(true);
    }
  };

  const hasHelpChat = React.useMemo(() => {
    switch (data?.tipoExibicaoChat) {
      case TipoExibicaoChat.BlipChat:
      case TipoExibicaoChat.MovideskChat:
        return true;
      default:
        return false;
    }
  }, [data]);

  function handleHelpChat() {
    switch (data?.tipoExibicaoChat) {
      case TipoExibicaoChat.BlipChat:
      case TipoExibicaoChat.BlipChatApenasAreaDeslogada:
        openBlipChat();
        break;
      case TipoExibicaoChat.MovideskChat:
      case TipoExibicaoChat.MovideskChatApenasAreaDeslogada:
        openMovideskChat();
        break;
    }
  }

  function handleOff() {
    if (canExit) {
      signOff();
    } else {
      setOpenClose(true);
    }
  }

  useEffect(() => {
    idVisual(data?.identidadeVisual);
    session?.user?.outrasUnidades?.map((item) => {
      if (item.podeVotar === true) {
        setNumberUnity(item.unidade.length);
      }
      setNameUnity(item.unidade);
    });
  }, [data, numberUnity, nameUnity]);

  function Subtitle() {
    return (
      <Flexible>
        {/* <Typography variant="caption" color="inherit">
          {
            (
              data?.dataLiberacaoVotacaoInicio &&
              format(new Date(data.dataLiberacaoVotacaoInicio), "'De ' dd ' de ' MMM ", { locale: PtBr }) +
              format(new Date(data.dataLiberacaoVotacaoFim), "'até ' dd ' de ' MMM ", { locale: PtBr })
            ) || (
              data?.dataVotacao &&
              format(new Date(data.dataVotacao), "dd ' de ' MMMM ' de ' yyyy", { locale: PtBr })
            )
          }
        </Typography> */}
        <Typography
          variant="caption"
          color="inherit"
          style={{ marginRight: '12px' }}
        >
          {data?.condominio &&
            data?.condominio.codigoCondominio +
              ' - ' +
              data?.condominio.nomeCondominio}
        </Typography>
        <BlueOnGreenTooltip
          title={
            numberUnity ? (
              <Unidade
                list={session?.user?.outrasUnidades?.map((item) => {
                  if (item.podeVotar === true) {
                    return <p>{item.unidade}</p>;
                  } else {
                    return (
                      <p
                        style={{
                          color: 'red',
                          fontWeight: 'bold',
                          fontSize: '16px'
                        }}
                      >
                        {item.unidade} ({item.motivoNaoPodeVotar})
                      </p>
                    );
                  }
                })}
              />
            ) : (
              ''
            )
          }
        >
          <Typography variant="caption" color="inherit">
            Unidades Representadas: {session?.user?.unidadeLogin?.unidade}
            {session?.user?.outrasUnidades?.map((item) => item.situacao === 2)
              ? `(+${
                  session?.user?.outrasUnidades
                    ?.map((item) => {
                      if (item.situacao === 2) {
                        return item;
                      }
                    })
                    .filter((unidades) => unidades !== undefined).length
                })`
              : ''}
          </Typography>
        </BlueOnGreenTooltip>
      </Flexible>
    );
  }

  return (
    <View
      style={{
        backgroundColor: isCustom ? customLayout['headerColor'] : '#083350'
      }}
    >
      <Optional valid={isCustom && customLayout['showLogoHubert']}>
        <img src={LogoHubert} height={100} alt="logo hubert" />
      </Optional>
      <Optional valid={!isCustom}>
        <img src={LogoHubert} height={100} alt="logo hubert" />
      </Optional>
      <Container style={{ gap: '6px' }}>
        <Row>
          <Column>
            <Row>
              <Title
                variant="h5"
                color="inherit"
                style={{ margin: '0 1rem', width: '100%' }}
              >
                {data?.descritivoVotacao}
              </Title>
              <HiddenOnDesktop>
                <Tooltip title={<Subtitle />} open={tooltip}>
                  <Icon onClick={() => setTooltip(!tooltip)}>info</Icon>
                </Tooltip>
              </HiddenOnDesktop>
            </Row>
            <Row>
              <HiddenOnMobile>
                <Subtitle />
              </HiddenOnMobile>
            </Row>
          </Column>
          <Spacer />
          <Column>
            <HiddenOnMobile>
              <Row style={{ gap: '20px' }}>
                {isCustom ? (
                  <HiddenOnMobile>
                    {/* {
                        customLayout["showLogoHubert"] ? (
                            <Logo width={120} sizes={'21'} src={logoHubert}></Logo>
                        ) : null
                      } */}
                    <Logo
                      width={100}
                      sizes={'12'}
                      src={customLayout['logoHeader']}
                      style={{ marginLeft: '12px', marginRight: '16px' }}
                    />
                  </HiddenOnMobile>
                ) : null}
                {hasHelpChat && (
                  <OptionButton
                    color="inherit"
                    onClick={handleHelpChat}
                    style={{
                      backgroundColor: '#FFFFFF',
                      borderRadius: '3px'
                    }}
                  >
                    {/* <img src={Help} alt="ajuda" width={18} height={18} /> */}
                    <Typography
                      variant="caption"
                      style={{
                        fontWeight: 'bold',
                        color: customLayout['headerColor'] || '#083F8B',
                        padding: '10px'
                      }}
                    >
                      Ajuda via chat
                    </Typography>
                  </OptionButton>
                )}
                <OptionButton
                  color="inherit"
                  onClick={handleOff}
                  style={{
                    backgroundColor: '#FFFFFF',
                    padding: '5px',
                    borderRadius: '3px'
                  }}
                >
                  {/* <img src={Exit} alt="sair" width={18} height={18} /> */}
                  <Typography
                    variant="caption"
                    style={{
                      fontWeight: 'bold',
                      color: customLayout['headerColor'] || '#083F8B',
                      padding: '10px'
                    }}
                  >
                    Sair
                  </Typography>
                </OptionButton>
              </Row>
            </HiddenOnMobile>
          </Column>
        </Row>
        <Column style={{ alignItems: 'end' }}>
          <HiddenOnDesktop>
            <Row style={{ gap: '6px' }}>
              {hasHelpChat && (
                <Button
                  color="inherit"
                  size="small"
                  onClick={handleHelpChat}
                  style={{
                    fontWeight: 'bold',
                    backgroundColor: '#FFFFFF',
                    color: customLayout['headerColor'] || '#083F8B',
                    borderRadius: '3px',
                    minHeight: '36px'
                  }}
                >
                  <Icon color={customLayout['headerColor'] || '#083F8B'}>
                    contact_support
                  </Icon>
                  Ajuda
                </Button>
              )}
              <Button
                color="inherit"
                size="small"
                onClick={handleOff}
                style={{
                  fontWeight: 'bold',
                  backgroundColor: '#FFFFFF',
                  color: customLayout['headerColor'] || '#083F8B',
                  borderRadius: '3px',
                  minHeight: '36px'
                }}
              >
                <Icon>logout</Icon>
                Sair
              </Button>
            </Row>
          </HiddenOnDesktop>
        </Column>
      </Container>
      <Dialog
        open={openClose}
        onClose={() => setOpenClose(false)}
        maxWidth="xs"
      >
        <DialogTitle>
          <Title
            variant="h5"
            color="primary"
            style={{
              textAlign: 'center',
              color:
                (customLayout['fontColor'] ?? '#000') < '#d3d3d3'
                  ? customLayout['fontColor']
                  : '#000'
            }}
          >
            {data?.situacao.codigoSituacao === 3
              ? 'Existem perguntas sem voto registrado, deseja mesmo sair?'
              : 'Deseja mesmo sair?'}
          </Title>
        </DialogTitle>
        <DialogContent>
          <Wrapper>
            <DialogActions
              style={{ display: 'flex', justifyContent: 'center' }}
            >
              <Button
                variant="contained"
                color="primary"
                style={{
                  width: '40%',
                  backgroundColor: customLayout['headerColor'] || '#083F8B'
                }}
                onClick={() => signOff()}
              >
                Sim
              </Button>
              <Button
                variant="contained"
                color="primary"
                style={{
                  width: '40%',
                  backgroundColor: customLayout['headerColor'] || '#083F8B'
                }}
                onClick={() => setOpenClose(false)}
              >
                Não
              </Button>
            </DialogActions>
          </Wrapper>
        </DialogContent>
      </Dialog>
    </View>
  );
};
